import { Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../Translations';

interface Props {
  href: string;
}

function TermsOfUseLink({ href }: Props) {
  return (
    <T
      kind="<link1>Terms ..."
      link1={(content) => (
        <a
          data-testid="footer_terms-of-use-link"
          data-test-terms-of-use-link={true}
          data-intercom-target="footer-terms-of-use-link"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Typography
            className="text-foreground underline hover:text-primary"
            variant="bodyMedium"
            fontWeight="semibold"
            as="span"
          >
            {content}
          </Typography>
        </a>
      )}
    />
  );
}

export default observer(TermsOfUseLink);
